let seeMoreBtn = document.querySelector('.grid__button-more');
let seeLessBtn = document.querySelector('.grid__button-less');
let allCollapsibleContent = document.querySelector('.grid__all-items');
if (seeMoreBtn) {
  seeMoreBtn.addEventListener('click', () => {
    allCollapsibleContent.classList.add('grid__all-items--is-visible');
    seeMoreBtn.classList.remove('grid__button-more--is-visible');
    seeLessBtn.classList.add('grid__button-less--is-visible');
  });
}
if (seeLessBtn) {
  seeLessBtn.addEventListener('click', () => {
    allCollapsibleContent.classList.remove('grid__all-items--is-visible');
    seeLessBtn.classList.remove('grid__button-less--is-visible');
    seeMoreBtn.classList.add('grid__button-more--is-visible');
  });
}

// Add rotate animation on svg when dropdown is opened
let dropdowns = document.querySelectorAll('summary');
dropdowns.forEach(dropdown => {
  dropdown.addEventListener('click', () => {
    let icon = dropdown.querySelector('.icon');
    icon.classList.toggle('rotate');
  });
});